export enum SidebarContentType {
  NONE,
  CUSTOMER,
  GOOD
}
